module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Fiche Pneumopathie.22abeba8dbcf0cded03f7b4160d4f09b.pdf";